import { Record } from 'immutable';
import { ConfigLookupType } from './config-lookup-type';
import { PropertyConfigLookup } from './property-config-lookup';
import { AgencyConfigLookup } from './agency-config-lookup';
import { CountryConfigLookup } from './country-config-lookup';

const ConfigRequestRecord = Record({
  config: null,
  property: null,
  agency: null,
  country: null
});

export class ConfigRequest extends ConfigRequestRecord {
  config: ConfigLookupType;
  property: PropertyConfigLookup;
  agency: AgencyConfigLookup;
  country: CountryConfigLookup;
}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/models/config/config-request.ts